(() => {
  if (window.__bstSalesforceAcsbBridge) return;
  window.__bstSalesforceAcsbBridge = true;

  const ROOT_SELECTORS = [
    '.embeddedServiceHelpButton',
    '.embeddedServiceSidebar',
    '.embeddedServiceSidebarLayout',
    '.embeddedServiceDesk',
    '.dockableContainer',
    '.showDockableContainer',
  ].join(',');

  const markSalesforceChatRoot = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.matches?.(ROOT_SELECTORS)) {
      node.setAttribute('data-acsb', 'true');
      node.setAttribute('data-acsb-hidden', 'true');
      node.setAttribute('data-acsb-force-hidden', 'true');
      node.setAttribute('data-acsb-force-unnavigable', 'true');
      node.setAttribute('acsb-alternative-menu-ignore', 'true');
    }

    node.querySelectorAll?.(ROOT_SELECTORS).forEach((el) => {
      el.setAttribute('data-acsb', 'true');
      el.setAttribute('data-acsb-hidden', 'true');
      el.setAttribute('data-acsb-force-hidden', 'true');
      el.setAttribute('data-acsb-force-unnavigable', 'true');
      el.setAttribute('acsb-alternative-menu-ignore', 'true');
    });

    node.querySelectorAll?.('iframe').forEach((iframe) => {
      const src = iframe.getAttribute('src') || '';
      const inSalesforceUi = iframe.closest(ROOT_SELECTORS);

      if (
        inSalesforceUi ||
        /salesforce|force\.com|liveagent|sfdc/i.test(src) ||
        /embeddedService|esw/i.test(iframe.className || '')
      ) {
        iframe.setAttribute('data-acsb', 'true');
        iframe.setAttribute('data-acsb-hidden', 'true');
        iframe.setAttribute('data-acsb-force-hidden', 'true');
        iframe.acsbIframeProcessed = true;
      }
    });
  };

  markSalesforceChatRoot(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        markSalesforceChatRoot(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
